import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { consumePendingReturnTo, getSafeReturnTo } from './oidc'
import { useAuth } from './AuthContext'

export function AuthPage() {
  const { configured, signingIn, signIn } = useAuth()
  const location = useLocation()
  const state = location.state as { returnTo?: unknown } | null
  const [returnTo] = useState(() => getSafeReturnTo(state?.returnTo ?? consumePendingReturnTo()))

  return (
    <main className="auth-screen">
      <div className="auth-backdrop" aria-hidden="true" />
      <section className="auth-card">
        <img className="auth-logo" src="/brand/logo.svg" alt="" />
        <h1>
          LightScape <em>Studio</em>
        </h1>
        <p>Turn layered images into living scenes.</p>
        <button
          type="button"
          disabled={!configured || signingIn}
          onClick={() => void signIn(returnTo)}
        >
          {signingIn ? 'Redirecting…' : 'Continue with baole.space'}
        </button>
        {!configured ? (
          <p role="alert" className="auth-fineprint auth-alert">
            Authentication is not configured.
          </p>
        ) : (
          <p className="auth-fineprint">One account for every baole.space app.</p>
        )}
        <a className="auth-home" href="/">
          ← Back to lightscape
        </a>
      </section>
    </main>
  )
}
